//React
import React, { useEffect, useState } from "react";
//Libraries
import cx from "classnames";
//Components
import { FlexBox, Image } from "components";
//Constants
import { sideMenuList, docsConstants } from "../../../constants";
//Styles
import "./styles.scss";
//Types
import { SideMenuProps } from "./types";
//Assets
import Logo from "assets/logo.svg";
//Slices
import {
  setGeneralDetails,
  useAllApplicationsApiDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
} from "Slices";
import { ChangeHistory, EventManager, EventNames, history } from "utils";
import ROUTE_PATH from "Routes/paths";

const SideMenu: React.FC<SideMenuProps> = ({
  isOpened,
  tabSelectCallback,
  scrolledToElement,
}) => {
  //Slices
  const generalDetails = useGeneralDetails();

  //Constants
  const [selectedTab, setSelectedTab] = useState(docsConstants.TITLES.OVERVIEW);
  const [selectedParentTab, setSelectedParentTab] = useState("");
  const [selectedGRandParentTab, setSelectedGRandParentTab] = useState("");
  const [disableActiveTabOmScroll, setDisableActiveTabOmScroll] =
    useState(false);

  //useEffects
  useEffect(() => {
    if (!generalDetails.activeSideMenuOption) {
      setGeneralDetails({
        activeSideMenuOption: sideMenuList[0]["text"],
      });
    }
  }, []);

  useEffect(() => {
    if (scrolledToElement && !disableActiveTabOmScroll) {
      setSelectedTab(scrolledToElement.selectedTab ?? "");
      setSelectedParentTab(scrolledToElement.selectedParentTab ?? "");
      setSelectedGRandParentTab(scrolledToElement.selectedGRandParentTab ?? "");
    }
  }, [scrolledToElement]);

  //Render UI
  const renderElement = (
    content: string,
    className: string,
    parent?: string,
    grandParent?: string,
    eventName?: string
  ) => {
    return (
      <p
        className={cx(
          className,
          selectedTab === content && "side-menu-option-active",
          selectedParentTab === content && "side-menu-option-active-parent",
          selectedGRandParentTab === content &&
            "side-menu-option-active-grand-parent",
          "curs-point, clicking-animation pd-h-20 pd-v-10 font-medium side-menu-option"
        )}
        onClick={() => {
          eventName && EventManager.send(eventName);
          setDisableActiveTabOmScroll(true);
          setSelectedTab(content);
          setSelectedParentTab(parent ?? "");
          setSelectedGRandParentTab(grandParent ?? "");
          tabSelectCallback?.(content);
          setTimeout(() => {
            setDisableActiveTabOmScroll(false);
          }, 1500);
        }}
      >
        {content}
      </p>
    );
  };

  const OldDocument = () => {
    return (
      <div className="pd-20">
        <a
          className="fs-12"
          href="https://docs.otpless.com/"
          target={"_self"}
          onClick={() => {
            EventManager.send(
              EventNames.EVENTS_NAME.DOCS.SIDE_MENU.OLD_DOCS_CLICK
            );
          }}
        >
          Old Documentation (V1)
        </a>
      </div>
    );
  };

  //Return UI
  return (
    <nav
      className={cx(
        isOpened && "docs-side-menu-opened",
        "docs-side-menu border-right"
      )}
    >
      <FlexBox flexColumn justifyBetween className="h-100">
        <div>
          <Image
            src={Logo}
            className="docs-side-menu-logo pd-20 clicking-animation"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.DOCS.SIDE_MENU.OLD_DOCS_CLICK
              );
              ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
            }}
          />
          {history.location.pathname === ROUTE_PATH.DOCS.HOME && (
            <>
              {renderElement(
                docsConstants.TITLES.OVERVIEW,
                "fs-16",
                EventNames.EVENTS_NAME.DOCS.SIDE_MENU.WELCOME_TO_DOCS
              )}
              {renderElement(
                docsConstants.TITLES.GET_STARTED_WITH_OTPLESS,
                "fs-16",
                EventNames.EVENTS_NAME.DOCS.SIDE_MENU.GET_STARTED
              )}
              {renderElement(
                docsConstants.TITLES.BACKEND_APIS,
                "fs-16",
                EventNames.EVENTS_NAME.DOCS.SIDE_MENU.BACKEND_APIS
              )}
              {renderElement(
                docsConstants.TITLES.SDK_AND_API_REFERENCE,
                "fs-16",
                EventNames.EVENTS_NAME.DOCS.SIDE_MENU.FRONTEND_SDKS
              )}
            </>
          )}
          {history.location.pathname === ROUTE_PATH.DOCS.API_REFERENCE && (
            <>
              {renderElement(docsConstants.TITLES.API_REFERENCE.TITLE, "fs-16")}
              {renderElement(docsConstants.TITLES.LOGIN_WITH_WHATSAPP, "fs-16")}
              {renderElement(
                docsConstants.TITLES.REST_API.INITIATE_LOGIN,
                "fs-14 mr-l-20 animated fadeInDown delay-01s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.API_REFERENCE.TITLE
              )}
              {renderElement(
                docsConstants.TITLES.REST_API.GET_USER_API,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.API_REFERENCE.TITLE
              )}
              {renderElement(
                docsConstants.TITLES.REST_API.POSTMAN_COLLECTION,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.API_REFERENCE.TITLE
              )}
            </>
          )}
          {history.location.pathname === ROUTE_PATH.DOCS.SDK.ANDROID && (
            <>
              {renderElement(docsConstants.TITLES.OVERVIEW, "fs-16")}
              {renderElement(docsConstants.TITLES.LOGIN_WITH_WHATSAPP, "fs-16")}
              {renderElement(
                docsConstants.TITLES.ANDROID.INSTALLATION,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.ANDROID.TITLE
              )}
              {renderElement(
                docsConstants.TITLES.ANDROID.USAGE,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.ANDROID.TITLE
              )}
            </>
          )}
          {history.location.pathname === ROUTE_PATH.DOCS.SDK.IOS && (
            <>
              {renderElement(docsConstants.TITLES.OVERVIEW, "fs-16")}
              {renderElement(docsConstants.TITLES.LOGIN_WITH_WHATSAPP, "fs-16")}
              {renderElement(
                docsConstants.TITLES.IOS.INSTALLATION,
                "fs-14 mr-l-20 animated fadeInDown delay-01s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.IOS.USAGE,
                "fs-14 mr-l-20 animated fadeInDown delay-01s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.IOS.HOW_IT_WORKS,
                "fs-14 mr-l-20 animated fadeInDown delay-01s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
            </>
          )}
          {history.location.pathname === ROUTE_PATH.DOCS.SDK.JAVASCRIPT && (
            <>
              {renderElement(docsConstants.TITLES.OVERVIEW, "fs-16")}
              {renderElement(docsConstants.TITLES.LOGIN_WITH_WHATSAPP, "fs-16")}
              {renderElement(
                docsConstants.TITLES.JAVASCRIPT.INSTALL,
                "fs-14 mr-l-20 animated fadeInDown delay-01s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.JAVASCRIPT.INITIALISE,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.JAVASCRIPT.METHOD,
                "fs-14 mr-l-20 animated fadeInDown delay-03s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
            </>
          )}
          {history.location.pathname === ROUTE_PATH.DOCS.SDK.FLUTTER && (
            <>
              {renderElement(docsConstants.TITLES.OVERVIEW, "fs-16")}
              {renderElement(docsConstants.TITLES.LOGIN_WITH_WHATSAPP, "fs-16")}
              {renderElement(
                docsConstants.TITLES.FLUTTER.INSTALL,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.FLUTTER.IMPORT,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.FLUTTER.INSTANCE,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.FLUTTER.METHOD,
                "fs-14 mr-l-20 animated fadeInDown delay-02s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {renderElement(
                docsConstants.TITLES.FLUTTER.NATIVE_PART,
                "fs-14 mr-l-20 animated fadeInDown delay-01s",
                docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
            </>
          )}
          {/* {(selectedTab === docsConstants.TITLES.SDK_AND_API_REFERENCE ||
            selectedParentTab === docsConstants.TITLES.SDK_AND_API_REFERENCE ||
            selectedGRandParentTab ===
              docsConstants.TITLES.SDK_AND_API_REFERENCE) && (
            <>
              {renderElement(
                docsConstants.TITLES.REST_API.TITLE,
                "fs-14 mr-l-10 animated fadeInDown delay-01s",
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {(selectedTab === docsConstants.TITLES.REST_API.TITLE ||
                selectedParentTab === docsConstants.TITLES.REST_API.TITLE) && (
                <>
                  {renderElement(
                    docsConstants.TITLES.REST_API.INITIATE_LOGIN,
                    "fs-14 mr-l-20 animated fadeInDown delay-01s",
                    docsConstants.TITLES.REST_API.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.REST_API.GET_USER_API,
                    "fs-14 mr-l-20 animated fadeInDown delay-02s",
                    docsConstants.TITLES.REST_API.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                </>
              )}

              {renderElement(
                docsConstants.TITLES.ANDROID.TITLE,
                "fs-14 mr-l-10 animated fadeInDown delay-03s",
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {(selectedTab === docsConstants.TITLES.ANDROID.TITLE ||
                selectedParentTab === docsConstants.TITLES.ANDROID.TITLE) && (
                <>
                  {renderElement(
                    docsConstants.TITLES.ANDROID.APP_SETUP,
                    "fs-14 mr-l-20 animated fadeInDown delay-01s",
                    docsConstants.TITLES.ANDROID.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.ANDROID.INSTALLATION,
                    "fs-14 mr-l-20 animated fadeInDown delay-02s",
                    docsConstants.TITLES.ANDROID.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.ANDROID.USAGE,
                    "fs-14 mr-l-20 animated fadeInDown delay-03s",
                    docsConstants.TITLES.ANDROID.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                </>
              )}
              {renderElement(
                docsConstants.TITLES.IOS.TITLE,
                "fs-14 mr-l-10 animated fadeInDown delay-04s",
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {(selectedTab === docsConstants.TITLES.IOS.TITLE ||
                selectedParentTab === docsConstants.TITLES.IOS.TITLE) && (
                <>
                  {renderElement(
                    docsConstants.TITLES.IOS.APP_SETUP,
                    "fs-14 mr-l-20 animated fadeInDown delay-01s",
                    docsConstants.TITLES.IOS.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.IOS.INSTALLATION,
                    "fs-14 mr-l-20 animated fadeInDown delay-02s",
                    docsConstants.TITLES.IOS.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.IOS.USAGE,
                    "fs-14 mr-l-20 animated fadeInDown delay-03s",
                    docsConstants.TITLES.IOS.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.IOS.HOW_IT_WORKS,
                    "fs-14 mr-l-20 animated fadeInDown delay-04s",
                    docsConstants.TITLES.IOS.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                </>
              )}
              {renderElement(
                docsConstants.TITLES.JAVASCRIPT.TITLE,
                "fs-14 mr-l-10 animated fadeInDown delay-04s",
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {(selectedTab === docsConstants.TITLES.JAVASCRIPT.TITLE ||
                selectedParentTab ===
                  docsConstants.TITLES.JAVASCRIPT.TITLE) && (
                <>
                  {renderElement(
                    docsConstants.TITLES.JAVASCRIPT.GET_STARTED,
                    "fs-14 mr-l-20 animated fadeInDown delay-01s",
                    docsConstants.TITLES.JAVASCRIPT.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                </>
              )}
              {renderElement(
                docsConstants.TITLES.FLUTTER.TITLE,
                "fs-14 mr-l-10 animated fadeInDown delay-05s",
                docsConstants.TITLES.SDK_AND_API_REFERENCE
              )}
              {(selectedTab === docsConstants.TITLES.FLUTTER.TITLE ||
                selectedParentTab === docsConstants.TITLES.FLUTTER.TITLE) && (
                <>
                  {renderElement(
                    docsConstants.TITLES.FLUTTER.NATIVE_PART,
                    "fs-14 mr-l-20 animated fadeInDown delay-01s",
                    docsConstants.TITLES.FLUTTER.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                  {renderElement(
                    docsConstants.TITLES.FLUTTER.FLUTTER_PART,
                    "fs-14 mr-l-20 animated fadeInDown delay-01s",
                    docsConstants.TITLES.FLUTTER.TITLE,
                    docsConstants.TITLES.SDK_AND_API_REFERENCE
                  )}
                </>
              )}
            </>
          )} */}
        </div>
        <OldDocument />
      </FlexBox>
    </nav>
  );
};
export default SideMenu;
